module.exports = __webpack_public_path__ + "static/media/line.cb776879.svg";